<template>
    <div :key="$i18n.locale">
        <div v-if="isLoading">
            <div id="overlay">
                <div class="loader"></div>
            </div>
        </div>
        <transition name="fade">
            <keep-alive>
                <router-view></router-view>
            </keep-alive>
        </transition>
    </div>
</template>
<script>
import Vue from 'vue'

import axios from 'axios'
import { mapState } from 'vuex'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

export default {
    name: 'beach_monitoring',
    data: () => ({
        menuVisible: false
    }),
    computed: {
        ...mapState(['isLoading', 'refCount'])
    },
    methods: {
        checkLoading(config) {
            var urllist = ['proxy']
            for (var index in urllist) {
                if (config.url.includes(urllist[index])) {
                    return true
                }
            }
            return false
        }
    },

    created() {
        axios.interceptors.request.use(
            (config) => {
                if (!this.checkLoading(config)) {
                    this.$store.commit('loading', true)
                }
                return config
            },
            (error) => {
                this.$store.commit('loading', false)
                return Promise.reject(error)
            }
        )

        axios.interceptors.response.use(
            (response) => {
                if (!this.checkLoading(response.config)) {
                    this.$store.commit('loading', false)
                }
                return response
            },
            (error) => {
                this.$store.commit('loading', false)
                return Promise.reject(error)
            }
        )
    },
    mounted() {
        var url = this.$store.state.base_url + '/api/cam_stations/'
        axios
            .get(url)
            .then((response) => {
                this.$store.commit('update_locations', response.data)
            })
            .catch((error) => {
                console.log(error)
            })
    },
    beforeDestroy: function () {}
}
</script>
<style lang="scss">
@import '~vue-material/dist/theme/engine';

@include md-register-theme(
    'default',
    (
        primary: #2dc6d6,
        // The primary color of your application
        accent: #00334c,
        // The accent or secondary color
    )
);

@import '~vue-material/dist/theme/all';

body {
    font-family: 'Roboto Condensed', sans-serif;
    font-size: 90%;
}
#content {
    min-height: 600px;
}

.loader {
    position: fixed;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 70px;
    height: 70px;
    left: 50%;
    top: 50%;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
}
#overlay {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: black;
    opacity: 0.5;
    z-index: 2000;
}

html,
body,
#app {
    width: 100vw;
    height: 100vh;
    overflow-x: hidden !important;
}

@import url(https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@300&display=swap);

body {
    font-family: 'Roboto Condensed', sans-serif !important;
    text-align: justify;
    color: #888;
}

#sidebar {
    width: 250px;
    background-color: #00334c;
    float: left;
    height: 100%;
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    overflow-x: hidden;
}

.link_separator {
    padding: 5px 5px 5px 5px;
    text-decoration: none;
    font-size: 20px;
    color: #2ec6d5;
    display: block;
    border-bottom: 1px solid #2ec6d5;
    margin-bottom: 5px;
}
#sidebar a {
    padding: 5px 5px 5px 5px;
    text-decoration: none;
    font-size: 16px;
    color: #d8e2ec;
    display: block;
    transition: 0.3s;
}
.submenu {
    border-left: 1px solid #82a7cd;
    margin-left: 20px;
}
#sidebar ul {
    list-style-type: none;
    padding: 5px;
}
#sidebar a:hover {
    color: #f1f1f1;
}

#container {
    /* Same as the width of the sidebar */
    padding: 0px;
    min-height: 600px;
}

.navbar-brand {
    color: #2dc6d6 !important;
    font-size: 30px;
}
.title {
    color: #2dc6d6 !important;
    font-size: 150%;
}
.navbar {
    border: 0px !important;
    margin: 0px !important;
}

.column-header,
.column-header a,
th,
td a,
td button {
    color: #2dc6d6 !important;
}
.tempform {
    border: 1px solid #2dc6d6;
}
.tempform table {
    margin: 20px;
}
.tempform table th {
    padding: 10px;
}

.section-body {
    padding-top: 60px;
    padding-bottom: 50px;
}

body {
    -webkit-font-smoothing: antialiased;
    color: #1d242e !important;
    text-align: justify;
}

.page-content {
    font-size: 23px;
    line-height: 33px;
}

.titulo_seccion {
    text-transform: uppercase;
    font-size: 24px;
    margin-bottom: 20px;
    font-weight: normal;
}

.titulo_seccion span {
    text-transform: none;
    font-family: 'Nexa';
    margin-left: 15px;
}

.h3 {
    margin: 10px;
}

p {
    text-align: justify;
    text-justify: inter-word;
}

span {
    color: rgb(0, 128, 128);
    line-height: 1.6em;
}

li {
    display: list-item;
    text-align: -webkit-match-parent;
    text-align: justify;
}

ul {
    display: block;
    list-style-type: disc;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
}
.slide-fade-enter-active {
    transition: all 0.3s ease;
}
.slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
}
span,
table th {
    color: #00334c !important;
}
</style>
